import axios from "axios"

export default {
    state : {
        facts : [],
    },
    getters : {
        facts(state) {
            return state.facts;
        },
    },
    mutations : {
        setFacts(state, facts) {
            state.facts = facts;
        },
    },
    actions : {
       async getFacts({commit}) {
          let res =  await axios.get(`/facts`);
          let facts = res.data;
          commit('setFacts', facts)
       },
    }
}